import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
// import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import './styles.css'

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    heading1: {
        fontSize: '15px',
        fontWeight: 700,
        color: '#000',
    },
    bottomLine: {
        // borderBottom: '1px solid #ccc !important',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
}));

const LabelA = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });
    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth className={classes.margin} disabled>
                    <InputLabel htmlFor="standard-adornment-amount">Description</InputLabel>
                    <Input
                        // disabled
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.name}
                        placeholder="Enter Description"
                        // onChange={handleChange('amount')}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth className={classes.margin} disabled>
                    <InputLabel htmlFor="standard-adornment-amount">Address </InputLabel>
                    <Input
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.pan}
                        placeholder="Enter Address"
                        // onChange={handleChange('amount')}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth className={classes.margin} disabled>
                    <InputLabel htmlFor="standard-adornment-amount">Amount(Cost) in Rs. </InputLabel>
                    <Input
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.value}
                        placeholder="Enter Amount"
                        // onChange={handleChange('amount')}
                    />
                </FormControl>
            </Grid>
            </Grid>
    )
}

export default LabelA
